<div class="animated fadeIn">
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-align-justify"></i>Enquiries
        </div>
        <div class="card-body">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Customer Name</th>
                <th>Date of Birth</th>
                <th>Passport Number</th>
                <th>Additional Information</th>
                <th>Submitted Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="
                  let item of modelCustomize
                    | paginate
                      : {
                          itemsPerPage: constants.itemsPerPage,
                          currentPage: parameter.page,
                          totalItems: parameter.total
                        };
                  let i = index
                "
              >
                <td>{{ i + 1 + (parameter.page - 1) * constants.itemsPerPage }}</td>
                <td>{{ item.customerName }}</td>
                <td>{{ item.dob || 'N/A' }}</td>
                <td>{{ item.passportNumber || 'N/A' }}</td>
                <td>
                  <span *ngIf="item.additionalInformation; else noInfo">
                    {{ item.additionalInformation.length > 50 ? (item.additionalInformation | slice:0:50) + '...' : item.additionalInformation }}
                  </span>
                  <ng-template #noInfo>N/A</ng-template>
                </td>
                <td>{{ item.createdAt | date: 'short' }}</td>
                <td>
                  <button
                    class="btn btn-sm btn-danger"
                    (click)="opendeletemodal(item._id, deleteModal, item.customerName)"
                  >
                    <i class="fa fa-trash"></i> Delete
                  </button>
                </td>
              </tr>
              <tr *ngIf="!modelCustomize || modelCustomize.length === 0">
                <td colspan="7" class="text-center">No enquiries found</td>
              </tr>
            </tbody>
          </table>
          <div class="d-flex justify-content-center">
            <pagination-controls
              (pageChange)="getPage($event); getEnquiries()"
            ></pagination-controls>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete Modal -->
<ng-template #deleteModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Enquiry</h4>
    <button
      type="button"
      class="close pull-right"
      aria-label="Close"
      (click)="modalRef.hide()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to delete enquiry for <strong>{{ deleteUserName }}</strong>?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="modalRef.hide()">
      Cancel
    </button>
    <button type="button" class="btn btn-danger" (click)="delete(deleteId)">
      Delete
    </button>
  </div>
</ng-template>

